<template>
  <div class="login henan">
    <div class="logins" v-if="!isLogin">
      <ul class="tab flex">
        <li v-for="(n,i) in tab" :class="{'active':active == i}" @click="active = i" :key="i">{{ n }}</li>
      </ul>
      <el-form :model="user" :rules="rules" ref="ruleForm" class="form" v-if="active == 0">
        <el-form-item prop="username">
          <img src="~/static/henan/public/user.png" alt="" class="icon">
          <el-input v-model="user.username" placeholder="请输入账号" size="mini"></el-input>
        </el-form-item>
        <el-form-item prop="password" class="password">
          <img src="~/static/henan/public/pass.png" alt="" class="icon">
          <el-input v-model="user.password" type="password" placeholder="请输入密码" size="mini" maxLength="18"></el-input>
          <router-link to="/user/password" target="_blank" class="pass">忘记密码？</router-link>
        </el-form-item>
        <el-form-item prop="imgCode">
          <img src="~/static/henan/public/code.png" alt="" class="icon">
          <ImageCode @changeCode="getchangeCode" ref="myImageCode" codeImg="codeImg"></ImageCode>
        </el-form-item>
      </el-form>
      <el-form :model="phone" :rules="phonerules" ref="ruleForms" class="form iphone" v-if="active == 1">
        <el-form-item prop="iphone">
          <img src="~/static/henan/public/user.png" alt="" class="icon">
          <el-input v-model="phone.iphone" placeholder="请输入手机号" size="mini"></el-input>
        </el-form-item>
        <el-form-item prop="code" class="code">
          <img src="~/static/henan/public/email.png" alt="" class="icon">
          <el-input v-model="phone.code" placeholder="请输入短信验证码" size="mini" maxLength="10">
          </el-input>
          <el-button type="text" @click="sendCheckCode" class="send" :class="{'disabled-style':getCodeBtnDisable}" :disabled="getCodeBtnDisable">{{ btntxt }}
          </el-button>
        </el-form-item>
      </el-form>
      <div class="buttons">
        <el-button type="primary" class="henan_btn" v-if="active == 0" @click="getLogin('ruleForm')" v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-background="#FFF" element-loading-text="正在登录" :disabled="loading">登录</el-button>
        <el-button type="primary" class="henan_btn" v-if="active == 1" @click="getLogin('ruleForms')" v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-background="#FFF" element-loading-text="正在登录" :disabled="loading">登录</el-button>
        <router-link to="/user/register/" target="_blank" class="sign_up">立即注册</router-link>
      </div>
    </div>
    <div class="is_login" v-else>
      <div class="avatar">
        <img :src="loginData.logo" alt="">
        <div class="name">
          {{ loginData.name }}
        </div>
      </div>
      <div class="schedule flex">
        <span>简历完善度</span>
        <div class="schedules">
          <div :style="{width:loginData.completeness}"></div>
        </div>
        <span>{{loginData.completeness}}</span>
      </div>
      <div class="buttons">
        <el-button type="primary" @click="refreshResume">刷新简历</el-button>
        <el-button type="primary" plain @click="$linkRouter('/center/resume?id='+loginType.id+'&userType='+loginType.userType)">编辑简历</el-button>
      </div>
      <ul class="list flex-wrap">
        <li>
          <router-link to="/center/work" target="_blank">
            <h4>{{loginData.apply || 0}}</h4>
            <p>我投递的</p>
          </router-link>
        </li>
        <li>
          <router-link to="/center/work?active=2" target="_blank">
            <h4>{{loginData.intention || 0}}</h4>
            <p>有意向</p>
          </router-link>
        </li>
        <li>
          <router-link to="/center/work?active=3" target="_blank">
            <h4>{{loginData.video || 0}}</h4>
            <p>视频邀请</p>
          </router-link>
        </li>
        <li>
           <router-link to="/center/work?active=3" target="_blank">
          <h4>{{loginData.interview || 0}}</h4>
          <p>面试邀请</p>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ImageCode from '@/components/login/ImageCode'
export default {
  name: 'login',
  inject: ['reload'],
  components: {
    ImageCode,
  },
  data() {
    return {
      loading: false,
      active: 0,
      form: {},
      checked1: '',
      btntxt: '获取验证码',
      getCodeBtnDisable: false,
      time: 61,
      i: '<i class="el-icon-d-arrow-right"></i>',
      user: {
        username: '',
        password: '',
        checked: false,
        imgCode: '',
        verifycode: '',
      },
      phone: {
        iphone: '',
        code: '',
        checked: false,
        imgCode: '',
        verifycode: '',
      },
      rules: {
        username: [
          { required: true, message: '请输入您的用户名', trigger: 'blur' },
        ],

        password: [
          { required: true, message: '请输入您的登录密码', trigger: 'blur' },
        ],
      },
      phonerules: {
        iphone: [
          {
            required: true,
            message: '请输入您的手机号码',
            trigger: 'blur',
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '手机号格式不对',
            trigger: 'blur',
          },
        ],
        code: [
          { required: true, message: '请输入收到的验证码', trigger: 'blur' },
        ],
      },
      temp: '',
      tab: ['密码登录', '短信登录'],
      isLogin: false,
      loginType: '',
      loginData: [],
    }
  },
  computed: {
    // 用于校验手机号码格式是否正确
    phoneNumberStyle() {
      let reg = /^1[3456789]\d{9}$/
      if (!reg.test(this.phone.iphone)) {
        return false
      }
      return true
    },
  },
  methods: {
    async getLongin() {
      this.isLogin = true
      let res = await this.$axios.get(
        '/api/app-jycy-henan/henan/main/page/disabledInfo'
      )
      this.loginData = res.data
    },
    close() {
      this.$emit('close', false)
    },
    // 键盘登录
    submits() {
      this.loginByuser()
    },
    tabs(i) {
      this.active = i
      this.loading = false
    },
    gettemp(val) {
      this.user.temp = val
    },
    // 刷新简历
    async refreshResume() {
      let res = await this.$api.refreshResume()
      if (res.data.success) {
        this.$message.success('刷新成功')
      }
    },
    getchangeCode(val) {
      this.user.verifycode = val.uuid
      this.user.imgCode = val.code
    },
    //手机号密码登录
    getLogin(form) {
      let that = this
      let param = {}
      if (this.active == 0) {
        param = {
          userName: this.user.username,
          password: this.user.password,
          code: this.user.imgCode,
          uuid: this.user.verifycode,
          loginType: '0',
          touristType: '1',
        }
      } else {
        param = {
          userName: this.phone.iphone,
          password: this.phone.code,
          loginType: '1',
          touristType: '1',
        }
      }
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          this.loading = true
          let res = await this.$api.getLoginApi(param)
          if (res.data.success) {
            this.loading = false
            let user = res.data.data
            that.$message.success('登录成功！')
            //残疾人个人信息
            that.$store.commit('SET_USER_INFO', user)
            //存储access_token
            that.$store.commit('SET_TOKEN', user.token)
            //存储refresh_token
            that.$store.commit('SET_REFRESH_TOKEN', user.token)
            if (user.userType === '1') {
              this.$router.go(-1)
              this.reload()
            } else if (user.userType === '2') {
              if (user.memberStatus == '0') {
                that.$router.push('/enterprise/centre/infomanage/')
              }
              this.$router.push('/enterprise')
              this.reload()
              this.loading = false
            } else {
              if (user.touristType == 2) {
                this.$router.push('/companyLogin/authentication')
              } else if (user.touristType == 1) {
                this.$router.push('/userLogin/authentication')
              }
            }
          } else {
            this.loading = false
            that.$message.error(res.data.msg)
          }
        } else {
          this.loading = false
        }
      })
    },
    sendCheckCode() {
      let iphone = /^1[3456789]\d{9}$/
      let codeAlert = localStorage.getItem('codeAlert')
      if (iphone.test(this.phone.iphone)) {
        if (this.$route.query.id == 'geren') {
          if (codeAlert) {
            this.sendMsg()
          } else {
            this.isHide = true
            return
          }
        } else {
          this.sendMsg()
        }
      } else {
        this.$message.error('手机号码不正确')
      }
    },
    // 单独领出来的短信发送接口
    sendMsg() {
      this.getCodeBtnDisable = true
      this.btntxt = '发送中...'
      this.$axios
        .post(
          '/api/app-jycy-phoneverificationcode/phoneVerification/' +
            this.phone.iphone
        )
        .then((res) => {
          if (res.data.success) {
            this.$message.success({
              message: '验证码已经发送至您的手机，请注意接收',
            })
            this.time = 180
            this.timer()
          } else {
            this.getCodeBtnDisable = false
            this.btntxt = '获取验证码'
            this.$message.error({
              message: res.data.msg || '发送失败',
            })
          }
        })
      this.handleClose()
    },
    //倒计时
    timer() {
      if (this.time > 0) {
        this.time--
        this.btntxt = this.time + 's后重新获取'
        setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.btntxt = '获取验证码'
        this.getCodeBtnDisable = false
      }
    },
  },
  created() {
    setTimeout(() => {
      this.loginType =
        this.$store.state.userType || localStorage.getItem('userType')
      if (this.loginType) {
        this.getLongin()
      }
    }, 500)
  },
}
</script>
<style scoped lang="less">
.login {
  width: 288px;
  height: 400px;
  padding: 30px 20px;
  background: white;

  .logins {
    .tab {
      display: flex;
      width: 100%;

      li {
        flex: 1;
        text-align: center;
        font-size: 16px;
        color: #6d6d6d;
        padding-bottom: 12px;
        cursor: pointer;
      }

      li.active {
        position: relative;
        color: #00210f;
      }

      li.active:after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 52px;
        height: 2px;
        background: #00924b;
      }
    }

    /deep/ .form {
      margin-top: 30px;

      .el-form-item {
        display: flex;
        .icon {
          position: absolute;
          top: 50%;
          left: 5px;
          transform: translateY(-50%);
          z-index: 100;
        }

        .el-form-item__content {
          width: 100%;
        }

        .el-input {
          width: 100%;
          font-size: 14px;
          color: #6d6d6d;
          border-bottom: 1px solid #eaeaea;

          .el-input__inner {
            text-indent: 1.2em;
            border: none;
            border-radius: 0;
          }
        }

        .image_code {
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
          z-index: 100;
          width: 68px;
          height: 28px;
          cursor: pointer;
        }

        /deep/ .send {
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
          font-size: 12px;
          color: #6d6d6d;
          border-bottom: 1px solid #eaeaea;
          padding: 0;
        }
        .pass {
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
          color: #949896;
        }
      }
      .code {
        position: relative;
        .send {
          position: absolute;
          right: 0;
          bottom: 5px;
        }
      }
    }
    /deep/ .iphone {
      .el-form-item {
        .el-form-item__content {
          line-height: 50px;
          button {
            font-size: 14px;
          }
        }
      }
    }
    .buttons {
      margin-top: 36px;
      text-align: right;
      .henan_btn {
        width: 100%;
      }
      .sign_up {
        display: block;
        font-size: 12px;
        color: #6d6d6d;
        margin-top: 12px;
      }
    }
  }
  .is_login {
    padding: 0 16px;
    background: white;
    .avatar {
      text-align: center;
      img {
        width: 68px;
        height: 68px;
        border-radius: 50%;
      }
      .name {
        font-size: 16px;
        font-weight: bold;
        margin-top: 10px;
      }
    }
    .schedule {
      margin: 20px 0;
      font-size: 12px;
      .schedules {
        width: 100px;
        height: 4px;
        border-radius: 2px;
        background: rgba(0, 189, 97, 0.2);
        margin: 8px 12px;
        div {
          width: 60%;
          height: 100%;
          background: #00bd61;
          border-radius: 2px;
        }
      }
    }
    .buttons {
      .el-button {
        padding: 8px 20px;
      }
    }
    ul.list {
      li {
        width: 50%;
        text-align: center;
        margin-top: 20px;
        h4 {
          font-size: 20px;
          font-weight: 400;
          color: #00924b;
        }
        p {
          margin-top: 15px;
          color: #666666;
        }
      }
    }
  }
}
</style>